// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SAVE_PROFILE = 'SAVE_PROFILE';
export const ACCOUNT_INITIALIZE = 'ACCOUNT_INITIALIZE';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';

// action global
export const UPDATE_UNSAVED_STATUS = '@global/UPDATE_UNSAVED_STATUS';
